<template>
  <div class="table-action-wrapper">
    <Select source="sale-account/search" placeholder="Sale Account" :value="query.account_id.value" @changeValue="changeAccountId"></Select>
    <Select source="user/search" type="auto" field="order.user_read" placeholder="Seller" :value="query.user_id.value" @changeValue="changeUserId"></Select>
    <button class="btn btn-outline-success ml-2" @click.stop.prevent="submit">Search</button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: {
        account_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Sales Account'
        },
        user_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Seller'
        }
      }
    }
  },
  methods: {
    changeAccountId(value, e) {
      this.query.account_id = Object.assign(this.query.account_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeUserId(value, e) {
      this.query.user_id = Object.assign(this.query.user_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    submit() {
      this.$emitter.emit('TableList.Refresh')
    }
  },
  props: {
    config: Object
  }
}
</script>
